import { Box } from '@mui/material'
import React from 'react'

type Props = {
  children: React.ReactNode
  fontSize?: string
}

const HighlightChip = (props: Props) => {
  return (
    <Box
      sx={{
        bgcolor: 'var(--yellow)',
        p: '5px 10px',
        borderRadius: '99px',
        width: 'fit-content',
        fontSize: props.fontSize ?? '12px',
      }}>
      {props.children}
    </Box>
  )
}

export default HighlightChip
